import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from '../../../core/services/loading.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';
import { SETTINGS } from '../../../core/config/common.settings';

@Injectable()
export class AdminForgotPasswordService {
  reqResetPasswordResponse: any = {};
  onReqResetPasswordResponseChange: Subject<any> = new BehaviorSubject({});

  forgotPasswordResponse: any = {};
  onForgotPasswordResponseChange: Subject<any> = new BehaviorSubject({});

  onVerifyEmailResponseChange: Subject<any> = new BehaviorSubject({});

  constructor(
    private http: HttpClient,
    private ngxService: LoadingService,
    private nzMessageService: NzMessageService,
    private router: Router
  ) {}

  requestResetPassword(data: any): Promise<any> {
    this.ngxService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/admin/request-reset-password`, { data })
        .subscribe({
          next: (response: any) => {
            this.ngxService.stop();
            this.reqResetPasswordResponse = response;
            this.onReqResetPasswordResponseChange.next(
              this.reqResetPasswordResponse
            );
            resolve(this.reqResetPasswordResponse);
          },
          error: error => {
            this.ngxService.stop();
            this.nzMessageService.error('Error');
            reject();
          },
        });
    });
  }

  validatePWResetToken(token: any): Promise<any> {
    this.ngxService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/admin/validate-reset-password`, { token })
        .subscribe({
          next: (response: any) => {
            if (response.done) {
              this.nzMessageService.success(response.message);
            } else {
              // this.nzMessageService.error(response.message);
            }
            this.forgotPasswordResponse = response;
            this.onForgotPasswordResponseChange.next(
              this.forgotPasswordResponse
            );
            this.ngxService.stop();
            resolve(this.forgotPasswordResponse);
          },
          error: error => {
            this.ngxService.stop();
            this.nzMessageService.error('Error');
            reject();
          },
        });
    });
  }

  resetPassword(payload: any): Promise<any> {
    this.ngxService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/admin/reset-password`, payload)
        .subscribe({
          next: (response: any) => {
            if (response.done) {
              this.nzMessageService.success(response.message);
              this.router.navigate(['/admin/login']);
            } else if (response.type) {
            } else {
              this.nzMessageService.error(response.message);
            }
            this.ngxService.stop();
            resolve(response);
          },
          error: error => {
            this.ngxService.stop();
            this.nzMessageService.error('Error');
            reject();
          },
        });
    });
  }

  verifyEmail(token: any): Promise<any> {
    this.ngxService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/admin/verification`, { token })
        .subscribe({
          next: (response: any) => {
            if (response.done) {
              this.nzMessageService.success(response.message);
              this.router.navigate(['/admin/login']);
            } else {
              this.nzMessageService.error(response.message);
            }
            this.ngxService.stop();
            this.onVerifyEmailResponseChange.next(response);
            resolve(response);
          },
          error: error => {
            this.ngxService.stop();
            this.nzMessageService.error('Error');
            reject();
          },
        });
    });
  }

  verificationEmailResend(email: any): Promise<any> {
    this.ngxService.start();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/patient/verification-email-resend`, {
          email,
        })
        .subscribe({
          next: (response: any) => {
            if (response.done) {
              this.nzMessageService.success(response.message);
            } else {
              this.nzMessageService.error(response.message);
            }
            this.ngxService.stop();
            resolve(response);
          },
          error: error => {
            this.ngxService.stop();
            this.nzMessageService.error('Error');
            reject();
          },
        });
    });
  }
}
